<template>
  <!-- <div class="publish"> -->
  <div class="exam-face" :class="[!openFace && 'closeModal']">
    <div class="face-title" @click="openFace = !openFace">
      <div class="title-text">考试监控</div>
      <img class="icon" src="../../assets/exam/switch.png" alt="" />
    </div>

    <div class="face-main">
      <div class="video-modal">
        <!-- 本地流区域 -->
        <!-- <div v-if="isHostMode" class="log-container" ref="logContainer">
          <div v-for="(item, index) in logList" :key="index">
        <span class="log-state" v-if="item.type === 'success'">🟩 </span>
        <span class="log-state" v-if="item.type === 'failed'">🟥 </span>
        <span>{{ item.log }}</span>
      </div>
        </div> -->
        <div v-if="localStream" class="local-stream-container" ref="video">
          <!-- 本地流播放区域 -->
          <div id="localStream" class="local-stream-content"></div>
        </div>
      </div>
      <video id="testVideo" style="display: none"></video>

      <!-- <video style="margin: 0 auto" ref="video"></video> -->
      <canvas
        style="display: none"
        width="387"
        height="350"
        id="canvasCamera"
      ></canvas>
    </div>
  </div>
</template>

<script>
import Api from "@/api/examList";
import rtc from "@/mixins/rtc.js";
import { getUrlParam, clearUrlParam } from "@/plugin/utils.js";
import LibGenerateTestUserSig from "@/plugin/lib-generate-test-usersig.min.js";

export default {
  mixins: [
    rtc,
    //  shareRtc
  ],
  props: {
    detail: {
      require: true,
      type: Object,
      default: {
        examName: "",
        beginTimeFormat: "",
        endTimeFormat: "",
        examTime: "",
        maxExamNum: "",
        examArrangeUid: "",
        examGradeUid: "",
        openCameraInvigilateInterval: 5,
        IsOpenFaceAuthentication: false,
        userId: "",
        roomId: "",
      },
    },
    isPushFlow: {
      require: true,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      type: "invite",
      sdkAppId: 1400685510,
      secretKey:
        "559fce13ef18b50c2cdd7c108304a94beda8aad6610049d997b3bc1906fd003f",
      userId: "user_61944471",
      roomId: 34724,
      isFace: false,
      isOk: false,
      mediaStreamTrack: {},
      video_stream: "", // 视频stream
      imgSrc: "", // 拍照图片
      canvas: null,
      context: null,
      openFace: true,
      isDiscern: false,
      faceInterval: null,
      logList: [],
      videoData: [],
      mainVideo: {},
      mediaRecorder: {},
      timeOut: null,
      timeCount: 0,
    };
  },
  created() {
    console.warn("打开人脸", this.detail);
    if (this.detail.userId && this.detail.roomId) {
      this.userId = this.detail.userId;
      this.roomId = String(this.detail.roomId);
      console.warn(this.roomId);
    }
    if (sessionStorage.getItem("videoTime")) {
      this.timeCount = Number(sessionStorage.getItem("videoTime"));
    }
    if (sessionStorage.getItem("trtcInfo")) {
      let trtcInfo = JSON.parse(sessionStorage.getItem("trtcInfo"));
      this.secretKey = trtcInfo.SecretKey;
      this.sdkAppId = Number(trtcInfo.SdkAppId);
    }
    (this.isOk = false), (this.isDiscern = false), (this.isFace = false);
  },
  mounted() {
    // 进入页面 自动调用摄像头
    // this.sdkAppId = Number(getUrlParam("sdkAppId"));
    // this.userSig = getUrlParam("userSig");
    // this.userId = getUrlParam("userId");
    // this.roomId = Number(getUrlParam("roomId"));
    // clearUrlParam();
    // this.handleJoinRoom();
    this.init();
    // this.OpenCamera();
    // }
  },
  destroyed() {
    if (this.faceInterval) {
      clearInterval(this.faceInterval);
    }
    // this.CloseCamera();

    this.handleLeave();
    this.localStream && this.destroyLocalStream();
    this.handleUnpublish();
  },
  computed: {
    isHostMode() {
      // return this.type !== "invite";
      return this.type == "invite";
    },
    shareUserId() {
      return `share_${this.userId}`;
    },
  },
  methods: {
    roundNum(min = 0, max = 0) {
      if (!isNaN(min) && !isNaN(max) && min >= 0 && max >= 0) {
        min > max ? ([min, max] = [max, min]) : ([min, max] = [min, max]);
        return parseInt((max - min + 1) * Math.random() + min);
      }
    },
    getVideo() {
      let MyViedeo = document.getElementById("testVideo");
      // console.warn("videoTag", this.localStream.videoPlayer_.div_.children[1]);
      this.mainVideo = this.localStream.videoPlayer_.div_.children[1];
      let mediaStream = this.localStream.getMediaStream();
      // console.warn("mediaStreammediaStreammediaStreammediaStream", mediaStream);
      MyViedeo.srcObject = mediaStream;
      let options = {
        audioBitsPerSecond: 128000,
      };
      // this.mediaRecorder = new MediaRecorder(this.mainVideo.captureStream(25),options);
      this.mediaRecorder = new MediaRecorder(
        MyViedeo.captureStream(25),
        options
      );
      this.mediaRecorder.ignoreMutedMedia = true;
      this.mediaRecorder.ondataavailable = (e) => {
        this.videoData.push(e.data);
      };
      if (
        this.detail.videoRecordingInterval &&
        this.detail.videoRecordingIntervalMax
      ) {
        let videoCount =
          this.roundNum(
            this.detail.videoRecordingInterval,
            this.detail.videoRecordingIntervalMax
          ) * 60;
        this.timeOut = setInterval(() => {
          this.timeCount++;
          sessionStorage.setItem("videoTime", this.timeCount);
          if (videoCount == this.timeCount) {
            this.startCapture();
            this.timeCount = 0;
            videoCount =
              this.roundNum(
                this.detail.videoRecordingInterval,
                this.detail.videoRecordingIntervalMax
              ) * 60;
          }
        }, 1000);
      }
    },
    startCapture() {
      this.mainVideo.play();
      console.warn("开始录制");
      this.mediaRecorder.start();
      setTimeout(() => {
        console.warn("停止录制");
        this.endCapture();
      }, 16000);
    },
    /*
     * 停止
     */
    endCapture() {
      this.mediaRecorder.stop();
      this.mainVideo.pause();
      setTimeout(() => {
        console.warn("播放录制");
        this.showCapture();
      }, 5000);
    },

    /*
     * 播放录制
     */
    showCapture() {
      return new Promise((resolve) => {
        setTimeout(() => {
          // Wrapping this in setTimeout, so its processed in the next RAF
          let blob = new Blob(this.videoData, {
            type: "video/mp4",
          });
          let videoUrl = window.URL.createObjectURL(blob);
          // displayVideo.src = videoUrl;
          console.warn(videoUrl);
          let formData = new FormData();
          let file = blob;
          file = new File([file], this.detail.examGradeUid);
          formData.append("file", file);
          formData.append("fileName", this.detail.examGradeUid);
          axios
            .post(`/api/app/file/upload-file-system`, formData)
            .then((res) => {
              let params = {
                userTag: this.userId,
                gradeUid: this.detail.examGradeUid,
                blobName: res.data.blobName,
                fileName: res.data.fileName,
                fileServerUrl: res.data.fileServerUrl,
                recordType: 2,
              };
              axios
                .post(
                  `/api/examservice/exam/${this.detail.examUid}/arranges/${this.detail.examArrangeUid}/monitor-files/relevance`,
                  params
                )
                .then((relevanceRes) => {
                  console.log(relevanceRes);
                });
            });
          resolve();
        }, 0);
      });
    },
    async init() {
      console.warn(
        "this.detail.openCameraInvigilateInterval",
        this.detail.openCameraInvigilateInterval
      );
      this.faceInterval = setInterval(() => {
        this.setImage();
        console.warn("抓拍定时器触发");
      }, this.detail.openCameraInvigilateInterval * 60000);
      const userSigGenerator = new LibGenerateTestUserSig(
        this.sdkAppId,
        this.secretKey,
        604800
      );
      this.userSig = userSigGenerator.genTestUserSig(this.userId);
      await this.initClient();
      await this.initLocalStream();
      await this.playLocalStream();
      if (this.detail.isOpenVideoRecording) {
        this.getVideo();
      }

      // this.faceInterval = setInterval(() => {
      //   this.setImage();
      // }, this.detail.openCameraInvigilateInterval * 60000);
      // setInterval(async () => {
      //   if (!this.isJoining) {
      // } else {
      //   await this.join();
      // }
      // await this.join();
      // await this.publish();
      // const CloseTime = setTimeout(() => {
      //   // this.handleUnpublish();
      //   this.handleLeave();
      //   console.warn("取消发布流");
      //   clearTimeout(CloseTime);
      // }, 3000);
      // }, 10000);
    },
    // 点击【Leave Room】按钮
    //离开房间
    async handleLeave() {
      console.warn("离开房间");
      await this.leave();
    },

    reportSuccessEvent(name) {
      // this.$aegis.reportEvent({
      //   name,
      //   ext1: `${name}-success`,
      //   ext2: "webrtcQuickDemoVue2",
      //   ext3: this.sdkAppId,
      // });
    },
    reportFailedEvent(name, error, type = "rtc") {
      // this.$aegis.reportEvent({
      //   name,
      //   ext1: `${name}-failed#${this.roomId}*${
      //     type === "share" ? this.shareUserId : this.userId
      //   }*${error.message}`,
      //   ext2: "webrtcQuickDemoVue2",
      //   ext3: this.sdkAppId,
      // });
    },
    // 显示成功的 Log
    addSuccessLog(log) {
      if (!this.isHostMode) {
        return;
      }
      this.logList.push({
        type: "success",
        log,
      });
      // const { scrollHeight } = this.$refs.logContainer;
      // this.$refs.logContainer.scrollTop = scrollHeight;
    },

    // 显示失败的 Log
    addFailedLog(log) {
      if (!this.isHostMode) {
        return;
      }
      this.logList.push({
        type: "failed",
        log,
      });
      const { scrollHeight } = this.$refs.logContainer;
      this.$refs.logContainer.scrollTop = scrollHeight;
    },
    generateInviteLink() {
      if (!this.isHostMode) {
        return;
      }
      const { sdkAppId, secretKey, roomId } = this;
      const inviteUserId = `user_${parseInt(Math.random() * 100000000, 10)}`;
      const userSigGenerator = new LibGenerateTestUserSig(
        sdkAppId,
        secretKey,
        604800
      );
      const inviteUserSig = userSigGenerator.genTestUserSig(inviteUserId);
      this.inviteLink = encodeURI(
        `${location.origin}${location.pathname}#/invite?sdkAppId=${sdkAppId}&userSig=${inviteUserSig}&roomId=${roomId}&userId=${inviteUserId}`
      );
    },
    // 点击【Join Room】按钮
    async handleJoinRoom() {
      if (this.isHostMode) {
        console.warn("通过");

        if (!this.sdkAppId || !this.secretKey) {
          alert(this.$t("Please enter sdkAppId and secretKey"));
          return;
        }
        if (!this.userId || !this.roomId) {
          alert(this.$t("Please enter userId and roomId"));
          return;
        }
        const userSigGenerator = new LibGenerateTestUserSig(
          this.sdkAppId,
          this.secretKey,
          604800
        );
        this.userSig = userSigGenerator.genTestUserSig(this.userId);
      } else {
        console.warn("未通过");

        if (
          !this.sdkAppId ||
          !this.inviteUserSig ||
          !this.userId ||
          !this.roomId
        ) {
          alert(this.$t("Please reacquire the invitation link"));
          return;
        }
        this.userSig = this.inviteUserSig;
      }
      await this.initClient();
      await this.join();
      await this.initLocalStream();
      await this.playLocalStream();
      console.warn("this.localStream", this.localStream);

      // this.detail.openCameraInvigilateInterval * 60000
      // await this.publish();
      // this.generateInviteLink();
    },

    // 点击【Publish】按钮
    async handlePublish() {
      await this.publish();
    },

    // 点击【Unpublish】按钮
    async handleUnpublish() {
      await this.unPublish();
    },
    openFaceRecognition() {
      this.isFace = true;
      this.OpenCamera();
    },
    handleClose() {
      this.CloseCamera();
      this.$emit("closepop"); //通知父组件改变。
    },
    // 调用打开摄像头功能
    getCamera() {
      // 获取 canvas 画布
      this.canvas = document.getElementById("canvasCamera");
      this.context = this.canvas.getContext("2d");
      // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      navigator.mediaDevices
        .getUserMedia({
          video: true,
        })
        .then((stream) => {
          // 摄像头开启成功
          this.mediaStreamTrack =
            typeof stream.stop === "function" ? stream : stream.getTracks()[0];
          this.video_stream = stream;
          this.$refs.video.srcObject = stream;
          if (stream.oninactive === null) {
            console.warn("监听流中断，流中断后将重新进行调用自身进行状态监测");
            // 监听流中断，流中断后将重新进行调用自身进行状态监测
            stream.oninactive = () => this.getCamera();
          }
          this.$refs.video.play();
          console.warn(
            "this.detail.openCameraInvigilateInterval",
            this.detail.openCameraInvigilateInterval
          );

          this.faceInterval = setInterval(() => {
            this.setImage();
            console.warn("抓拍定时器触发");
          }, this.detail.openCameraInvigilateInterval * 60000);
        })
        .catch((err) => {
          console.log(err);
          let message = error.message || error,
            response = {
              "permission denied":
                "浏览器禁止本页面使用摄像头，请开启相关的权限",
              "requested device not found": "未检测到摄像头",
              "could not start video source":
                "无法访问到摄像头，请重新插拔后重试",
            };

          this.$message.error(
            response[message.toLowerCase()] ||
              "摄像头开启失败，请检查摄像头是否可用！"
          );
        });
    },

    loadWebCamera() {
      let cameraIsOnline = false;

      let mediaDevices = navigator.mediaDevices || null;

      if (mediaDevices === null) {
        console.warn(`请确定是否处于https协议环境下`);
        return;
      }

      mediaDevices
        .getUserMedia({ audio: false, video: true })
        .then(async (stream) => {
          let video = document.getElementById("#video");

          video.srcObject = stream;

          // 兼容性处理
          if (stream.oninactive === null) {
            // 监听流中断，流中断后将重新进行调用自身进行状态监测
            stream.oninactive = () => loadWebCamera();
          }

          await video.play();

          cameraIsOnline = true;
        })
        .catch((error) => {
          let message = error.message || error,
            response = {
              "permission denied":
                "浏览器禁止本页面使用摄像头，请开启相关的权限",
              "requested device not found": "未检测到摄像头",
              "could not start video source":
                "无法访问到摄像头，请重新插拔后重试",
            };

          cameraIsOnline = false;
          alert(response[message.toLowerCase()] || "未知错误");
        });
    },
    // 拍照 绘制图片
    setImage() {
      console.log("拍照");
      // 点击canvas画图
      // 获取图片base64链接
      const frame = this.localStream.getVideoFrame();
      if (frame) {
        this.imgSrc = frame;
        if (this.imgSrc) {
          this.checkFace(this.imgSrc);
        } else {
          let haveImg = setInterval(() => {
            if (this.imgSrc) {
              this.checkFace(this.imgSrc);
              clearInterval(haveImg);
            }
          }, 300000);
        }
        // const img = document.createElement("img");
        // img.src = frame;
        // console.warn('imgimg',img);
      }
      // this.context.drawImage(this.$refs.video, 0, 0, 480, 320);
      // const image = this.canvas.toDataURL("image/png");
      // this.imgSrc = image;
    },
    checkFace(imgSrc) {
      let params = {};
      params.image = imgSrc;
      params.batchId = this.detail.examArrangeUid;
      params.relationId = this.detail.examGradeUid;
      params.sourceType = "examing";
      params.callConfigList = [0, 3];
      Api.verifyFaceAll(params)
        .then((res) => {
          if (res.data.status === 1) {
            if (res.data.businessData.isSuccess) {
              console.warn(res.data);
            } else {
              console.warn(res.data);
            }
          } else {
            this.$message.error(res.data.errorMessage);
          }
          console.warn(res);
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    // 打开摄像头
    OpenCamera() {
      console.log("打开摄像头");
      this.getCamera();
    },
    // 关闭摄像头
    CloseCamera() {
      console.log("关闭摄像头");
      this.MediaStreamTrack && this.MediaStreamTrack.stop();
      this.$refs.video.srcObject.getTracks()[0].stop();
    },
  },
  watch: {
    isPushFlow: {
      async handler(newVal, oldVal) {
        if (newVal == true) {
          console.warn("isPushFlow==true");
          await this.join();
          await this.publish();
        } else {
          this.handleUnpublish();
          this.handleLeave();
        }
      },
      // 开启深度监听：只要obj中的任何一个属性发生改变，都会触发相应的代码
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
video {
  // width: 387px;
  // width: 200px;
  height: 200px;
  border: 2px solid #ffffff;
  border-radius: 8px;
  // height: 300px;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.16);
}
.exam-face {
  width: 386px;
  // height: 210px;
  background: linear-gradient(
    136deg,
    rgba(255, 255, 255, 0.82),
    rgba(255, 255, 255, 0.8) 100%
  );
  border: 1.5px dashed #ffffff;
  border-radius: 15px;
  box-shadow: 0px 2px 5.5px 0px rgba(0, 0, 0, 0.02);
  backdrop-filter: blur(8.4px);
  &.closeModal {
    height: 52px;
    overflow: hidden;
    .icon {
      transform: rotate(180deg);
    }
  }

  .face-title {
    width: 100%;
    height: 52px;
    background: #102345;
    border-radius: 15px 15px 0px 0px;

    display: flex;
    padding: 0 16px;

    align-items: center;
    justify-content: space-between;
    .title-text {
      font-size: 18px;
      font-weight: 400;
      text-align: left;
      color: #ffffff;
      display: inline-block;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        border: 3px solid #fa6a67;
        border-radius: 50%;
        width: 8px;
        height: 8px;
        right: -25px;
        top: 50%;
        margin-top: -6px;
      }
    }
  }
  .face-main {
    width: 100%;
    height: 180px;
    display: flex;
    justify-content: center;
    align-items: center;
    .video-modal {
      height: 150px;
      width: 280px;
      border: 2px solid #ffffff;
      border-radius: 8px;
      // height: 300px;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.16);

      .local-stream-container {
        height: 100% !important;
      }
      .local-stream-content {
        height: 100% !important;
        video {
          margin: 0 auto;
          height: 150px !important;
          border: 2px solid #ffffff;
          border-radius: 8px;
          // height: 300px;
          box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.16);
        }
        ::v-deep div {
          background-color: #ffffff !important;
        }
      }
    }
  }
}
</style>